const DEFAULT_ELLIPSIS = "...";

let measureContext: CanvasRenderingContext2D | null = null;

function getMeasureContext(): CanvasRenderingContext2D | null {
  if (typeof document === "undefined") {
    return null;
  }
  if (!measureContext) {
    measureContext = document.createElement("canvas").getContext("2d");
  }
  return measureContext;
}

/** `element` に適用されているフォントを `canvas.measureText` 用の font 文字列に変換する */
export function getElementFont(element: HTMLElement): string {
  const style = window.getComputedStyle(element);
  return `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
}

/**
 * 文字列の中央部分を省略記号に置き換えて `maxWidth`（px）に収める。
 * CSS の `text-overflow: ellipsis` は末尾のみの省略のため、原稿タイトルのように
 * 先頭・末尾の両方の情報を残したい箇所ではこちらを使う。
 */
export function truncateMiddleToWidth(
  text: string,
  maxWidth: number,
  font: string,
  ellipsis: string = DEFAULT_ELLIPSIS
): string {
  const ctx = getMeasureContext();
  if (!ctx || maxWidth <= 0) {
    return text;
  }
  ctx.font = font;
  if (ctx.measureText(text).width <= maxWidth) {
    return text;
  }

  const ellipsisWidth = ctx.measureText(ellipsis).width;
  if (ellipsisWidth >= maxWidth) {
    return ellipsis;
  }

  // サロゲートペア（絵文字等）を分断しないよう、UTF-16コードユニットではなく
  // Unicodeコードポイント単位で扱う
  const chars = Array.from(text);
  let front = "";
  let back = "";
  let start = 0;
  let end = chars.length;
  while (start < end) {
    const nextFront = front + chars[start];
    const nextBack = chars[end - 1] + back;
    if (ctx.measureText(nextFront).width + ctx.measureText(nextBack).width + ellipsisWidth > maxWidth) {
      break;
    }
    front = nextFront;
    back = nextBack;
    start += 1;
    end -= 1;
  }
  return `${front}${ellipsis}${back}`;
}
